/* Handles the items in the wish list on the wish list page */
customElements.define('wishlist-page-items', class WishlistPageItems extends HTMLElement {
    constructor() {
        super();
        this.wishlistDataElement = document.querySelector('wishlist-data'); // the custom element wishlist-data handles data for the wish list
        this.publicWishListId = null;
        this.hasLoadedFirstTime = false;
        this.isWishlistOwner = false;
        this.isB2B = document.body.classList.contains('body--b2b');

        // after this function has been called it removed event listeners calling it
        const theInitCallback = (e) => {
            const event = e ? e : null;
            this.getWishlistIdFromUrlOrServerAndInit(event);
            document.removeEventListener('newWishlistDataLoaded', theInitCallback);
            document.removeEventListener('anonymousUserNoWishlist', theInitCallback);
        }

        document.addEventListener('newWishlistDataLoaded', theInitCallback);
        document.addEventListener('anonymousUserNoWishlist', theInitCallback);
        if(window.anonymousUserNoWishlist) {
            theInitCallback();
        }

        document.addEventListener('newWishlistDataLoaded', (e) => {
            this.updateWishlistData(e);
        });
    }

    /**
     * If data for current wishlist is updated, update the shown
     * wishlist (this should only happen when the wishlist shown
     * is your own and current wish list)
     * @param {event} e event telling that data on current wishlist is updated
     */
    updateWishlistData(e) {
        if(this.isWishlistOwner && e.detail.wishlistPage === false) {
            window.wishlistPageShownWishlist = window.currentWishlist;
            this.publicWishListId = window.currentWishlist.publicWishListId;
            this.init();
        }
    }

    /**
     * called when wishlist id has been found
     * find wish list content and show it
     */
    async init() {
        if(!this.publicWishListId) {console.error('No Public Wish List Id'); return;}
        if(this.publicWishListId && !window.wishlistPageShownWishlist) {
            await this.getWishlistFromPublicId();
        }
        this.setOwningStatus();
        this.setPageHeader();
        // show elements
        if(!window.wishlistPageShownWishlist.products.length) {
            this.handleEmptyWishlist();
        } else {
            this.getWishlistItems();
            // change url
            this.setWishlistSpecificUrl();

            //init share component and signup components
            const event = new CustomEvent('wishlistItemsInited');
            document.dispatchEvent(event);
        }
    }

    /**
     * sets the page header text according to whether the list
     * is owned by another user or not
     */
    setPageHeader() {
        const pageHeader = document.getElementById('js-wishlist-page-heading');
        if(!pageHeader) { console.error('No page header'); return; }
        let pageHeaderAttribute = 'data-title-shared';
        if(this.isWishlistOwner) {
            pageHeaderAttribute = 'data-title-owned';
        }
        pageHeader.innerHTML = pageHeader.getAttribute(pageHeaderAttribute);
    }

    /**
     * set property on this custom element to tell if the
     * user owns the wish list shown on the wish list page
     */
    setOwningStatus() {
        this.isWishlistOwner = false;
        if(window.currentWishlist && window.wishlistPageShownWishlist && window.currentWishlist.publicWishListId === window.wishlistPageShownWishlist.publicWishListId) {
            this.isWishlistOwner = true;
        } else if(window.customer) {
            this.isWishlistOwner = window.wishlistPageShownWishlist.isOwner ? true : false;
        }
    }

    /**
     * find wish list from public Id
     */
    async getWishlistFromPublicId() {
        let sessionIdQueryPart = '';
        if(window.currentWishlist && window.currentWishlist.sessionId) {
            const saneData = this.wishlistDataElement.saneProperties({sessionId: window.currentWishlist.sessionId});
            if(!saneData) {
                console.error('Error, getWishlistFromPublicId data not valid');
                this.wishlistDataElement.showErrorPopup();
                return;
            }
            sessionIdQueryPart = `&sessionId=${window.currentWishlist.sessionId}`;
        }
        await fetch(`/apps/wishlist/wishlistpage?publicwishlistid=${this.publicWishListId}${sessionIdQueryPart}`)
        .then((response) => {
            return response.json();
        })
        .then((returnedJson) => {
            this.wishlistDataElement.handleNewData(returnedJson,true,'getWishlistFromPublicId');
            if(returnedJson.errorMessage) {
                console.error(`Error in getWishlistFromPublicId: ${returnedJson.errorMessage}`);
                this.wishlistDataElement.showErrorPopup(returnedJson.errorMessage);
            }
        }).catch(error => {
            console.error(`Error in getWishlistFromPublicId (2): ${error}`);
            this.wishlistDataElement.showErrorPopup();
        });
    }

    /**
     * show message from template if wish list is empty
     */
    handleEmptyWishlist() {
        const elementsToDelete = document.querySelectorAll('wishlist-signup-encouraging, wishlist-share');
        elementsToDelete.forEach(element => {
            element.remove();
        });
        const wishlistHolder = this.closest('.wishlist-page-items');
        if(!wishlistHolder) {return;}
        const templateEmptyWishlist = wishlistHolder.querySelector('#template-empty-wishlist');
        if(!templateEmptyWishlist) {return;}
        const emptyWishListHtml = templateEmptyWishlist.content;
        wishlistHolder.innerHTML = '';
        wishlistHolder.appendChild(emptyWishListHtml);
        const resultAmountEl = document.getElementById('wishlist-result-amount');
        resultAmountEl.remove();
    }

    /**
     * finds the wish list to show and sets its ID as this.publicWishListId to be
     * used for showing the wishlist. If there's no wish list, redirect to the
     * frontpage and show a message
     */
    getWishlistIdFromUrlOrServerAndInit(e) {
        const urlParams = new URL(window.location.href).searchParams;
        // check if there's a seemingly legit wishlist id in the url and get wishlist from that
        if(urlParams.get('wishlistid')) {
            const sessionRegex = /([A-Za-z0-9-])/;
            const sessionValidationResult = sessionRegex.test(urlParams.get('wishlistid'));
            if(!sessionValidationResult) {
                console.error('Get session failed because of wrong url');
                return;
            }
            this.publicWishListId = urlParams.get('wishlistid');
            this.init();
        } else if(window.currentWishlist && window.currentWishlist.publicWishListId) { // if there's no wishlist id in the url look for current wishlist
            window.wishlistPageShownWishlist = window.currentWishlist;
            this.publicWishListId = window.currentWishlist.publicWishListId;
            this.init();
        } else {
            if(!window.customer && !window.localStorage.getItem('wishlistSessionId')) {
                this.handleEmptyWishlist();
            } else {
                // otherwise update the currently shown wishlist
                this.updateWishlistData(e);
            }
        }
    }

    /**
     * find stylesheets used in the html from the search page and
     * add them to the current page in order to have correct styling
     * of the product cards in the wish list
     *
     * this function should only be called first time a search is performed
     *
     * @param {html element} resultsWrapper
     */
    getAndAppendProductListStylesAndJs(resultsWrapper) {
        const stylesheets = resultsWrapper.querySelectorAll('link[rel="stylesheet"]');
        for (let i = 0; i < stylesheets.length; i++) {
            const element = stylesheets[i];
            this.loadStyle(element);
        }
    }

    /**
     * append style sheet to head of document
     *
     * @param {html element} stylesheetTag
     * @returns
     */
    loadStyle(stylesheetTag) {
        // avoid duplicates
        const href = stylesheetTag.href;
        for(var i = 0; i < document.styleSheets.length; i++) {
            if(document.styleSheets[i].href == href) {
                return;
            }
        }
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = href;
        head.appendChild(link);
    }

    /**
     * find the sorting method for the wishlist items, if there is any
     * @returns the sort_by url parameter, if it exists
     */
    getSorting() {
        const urlParams = new URL(window.location.href).searchParams;
        const sort_by = urlParams.get('sort_by');
        if(sort_by) {
            return `&sort_by=${sort_by}`
        }
        return '';
    }

    /**
     * find wish list items by searching for their id's
     */
    async getWishlistItems() {
        if(!window.wishlistPageShownWishlist || !window.wishlistPageShownWishlist.products) {console.error('Error: no wishlist available in getWishlistItems');return;}
        const wishlistProducts = window.wishlistPageShownWishlist.products;
        const queryString = wishlistProducts.map(x => x.productId).join('%20OR%20id:');
        const sectionToRender = 'wishlist-page-search-results';
        const sorting = this.isB2B ? this.getSorting() : '';
        const isOwner = this.isWishlistOwner ? '' : '&notowner=true'

        await fetch(`${window.localizationPrefix}/search?q=id:${queryString}&section_id=${sectionToRender}${isOwner}${sorting}`)
        .then((response) => {
          return response.text();
        })
        .then((results) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(results, 'text/html');
            this.handleWishlistPageResults(doc);
        }).catch(error => {
            console.error(`Error in getWishlistItems (2): ${error}`);
          }
        );
    }

    getQtyFromWishListData(productId) {
        const wishlistEntry = window.currentWishlist.products.find(x => x.variantId === productId);
        if(wishlistEntry?.quantity) {
            return wishlistEntry.quantity;
        }
        return 1;
    }

    /**
     * when search page has returned results, use this function to
     * handle the data from the search page
     *
     * @param {document} doc
     */
    handleWishlistPageResults(doc) {
        const wrapperForAll = doc.querySelector('#shopify-section-wishlist-page-search-results');
        //add class so that safari only needs to repaint ajax-loadet images
        const images = wrapperForAll.getElementsByTagName('img');
        for (let i = 0; i < images.length; i++) {
            const element = images[i];
            element.classList.add('ajax-loadet');
        }

        if(!this.hasLoadedFirstTime && wrapperForAll) {
            this.getAndAppendProductListStylesAndJs(wrapperForAll);
            this.hasLoadedFirstTime = true;
        }

        const resultList = wrapperForAll.querySelector('#ProductGridContainer');
        const itemAmount = resultList.getAttribute('data-result-text');
        const sortingOptions = wrapperForAll.querySelector('#sorting_options');

        document.getElementById('wishlist-result-amount').innerText = itemAmount;
        const wishlistPageSortingElement = document.querySelector('wishlist-page-sorting');
        if(wishlistPageSortingElement){
            wishlistPageSortingElement.innerHTML = '';
            wishlistPageSortingElement.append(sortingOptions);
        }
        this.innerHTML = '';
        if(this.isB2B) {
            const resultListQuantityInputs = resultList.getElementsByClassName('quantity__input');
            [...resultListQuantityInputs].forEach(qtyInput => {
                const prodId = parseInt(qtyInput.id.replace('Quantity-wishlist-page-search-results--', ''), 10);
                const qty = this.getQtyFromWishListData(prodId);
                qtyInput.value = qty;
            });
        }

        this.append(resultList);

        this.handleHideHeaderIconIfNotOwner();

        if(window.wishlistPageShownWishlist) {
            const event = new CustomEvent('newWishlistPageLoaded',{detail:{wishlistPage: true, allVariantIds: window.wishlistPageShownWishlist.allVariantIds}});
            document.dispatchEvent(event);
        }
    }

    /**
     * If the user does not own the wish list, hide the
     * wish list icon in the header to avoid confusion
     */
    handleHideHeaderIconIfNotOwner() {
        const headerIcon = document.querySelector('.header__icon--wishlist');
        if(!headerIcon) { return; }
        if(this.isWishlistOwner) {
            headerIcon.classList.remove('hidden');
        } else {
            headerIcon.classList.add('hidden');
        }
    }

    /**
     * set the url of the current page so that it contains the public id of the shown wish list
     */
    setWishlistSpecificUrl() {
        if(this.getAttribute('data-designmode') === 'false') {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('wishlistid', window.wishlistPageShownWishlist.publicWishListId);
            window.history.replaceState({ }, '', newUrl);
        }

        // send event so that share url can update
        const event = new CustomEvent('remakeShareValueFromUrl');
        document.dispatchEvent(event);
    }
});


/**
 * custom elements for handling all items in the
 * shown/current wish list
 */
class WishlistPageControls extends HTMLElement {
    constructor() {
        super();
        this.wishlistDataElement = document.querySelector('wishlist-data');
        this.disabledClass = 'wishlist-page-controls__button--loading';
        this.btn = this.querySelector('button');
        if (!this.btn) {
            return;
        }
    }

    /**
     * when wish list items have been loaded, enable the
     * "add all to cart"-button
     */
    init(){
        this.confirmBox = document.getElementById(this.confirmBoxId);
        document.addEventListener('newWishlistPageLoaded', () => {
            this.enableButton();
        });
    }

    /**
     * make button available for clicking
     */
    enableButton(){
        this.btn.classList.remove(this.disabledClass);
        this.btn.removeAttribute('disabled');
    }

    /**
     * make button unavailable for clicking (when loading or
     * when waiting for confirm box)
     */
    disableButton(){
        this.btn = this.querySelector('button');
        this.btn.classList.add(this.disabledClass);
        this.btn.setAttribute('disabled','disabled');
    }

    /**
     * show confirm box and wait for user to confirm if they
     * want to add all products in wish list to the cart or not
     *
     * @returns true if it is confirmed to add all and false if not
     */
    waitForUserConfirm() {
        this.confirmBox.showModal();
        return new Promise(resolve => {
            const confirmBtns = this.confirmBox.getElementsByClassName('js-button--confirm-box');

            const myCallback = (e) => {
                const isConfirmed = e.target.value === 'confirm';
                this.confirmBox.close();

                for (let i = 0; i < confirmBtns.length; i++) {
                    const btn = confirmBtns[i];
                    btn.removeEventListener('click', myCallback);
                }
                resolve(isConfirmed);
            }

            for (let i = 0; i < confirmBtns.length; i++) {
                const btn = confirmBtns[i];
                btn.addEventListener('click', myCallback);
            }
        })
    }
  }
  customElements.define('wishlist-page-controls', WishlistPageControls);



/**
 * custom element for handling adding all items in the
 * shown/current wish list to the cart
 */
class addAllFromWishlistToCart extends WishlistPageControls {
    constructor() {
        super();
        this.cartNotification = document.querySelector('cart-notification');
        this.confirmBoxId = 'confirm-add-all';
        this.btn.addEventListener('click', this.addProductsToCartByID.bind(this));
        this.init();
    }

    /**
     * if confirmed, add all products on the current page to the cart
     * @param {event} e
     */
    async addProductsToCartByID(e) {
        this.disableButton();
        if(await this.waitForUserConfirm()) {
            e.preventDefault();
            e.stopPropagation();
            const prodForms = document.querySelectorAll('wishlist-page-items product-form');
            let formData = {
                items: [],
                sections: this.cartNotification.getSectionsToRender().map((section) => section.id)
            };
            prodForms.forEach(x => {
                let obj = {};
                const xForm = x.querySelector('form');
                if(window.isB2cSite === true) {
                    obj.quantity = 1;
                } else if(window.isB2bSite === true) {
                    obj.quantity = xForm.elements['quantity'].value;
                }

                obj.id = x.querySelector('input[name="id"]').value;
                obj.properties = {};
                for (let i = 0; i < xForm.elements.length; i++) {
                    const formEl = xForm.elements[i];
                    const currentTag =formEl.tagName.toLowerCase();
                    const first11 =formEl.name.substring(0, 11);
                    if(currentTag === 'input' && first11 === 'properties[') {
                        let fieldName =formEl.name.substring(11);
                        fieldName = fieldName.replace(']','');
                        obj.properties[fieldName] =formEl.value;
                    }
                }

                formData.items.push(obj);
            });
            let currentAmountInCart = 0;
            const newBubbleElem = document.getElementById('cart-icon-bubble').querySelector('.cart-count-bubble > span:first-child');
            if(newBubbleElem) {
                currentAmountInCart = parseInt(newBubbleElem.innerText, 10);
            }

            await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(returnedJson => {
                if(returnedJson.message) {
                    const errorMsg = {
                        header: returnedJson.message,
                        message: returnedJson.description
                    }
                    this.wishlistDataElement.showErrorPopup(errorMsg);
                } else {
                    let newAmountInCart = new DOMParser()
                    .parseFromString(returnedJson.sections['cart-icon-bubble'], 'text/html')
                    .querySelector('.cart-count-bubble > span:first-child').innerText;
                    newAmountInCart = parseInt(newAmountInCart, 10);
                    const amountAdded = newAmountInCart - currentAmountInCart;
                    document.getElementById('cart-notification__heading-count').innerText = amountAdded;

                    this.cartNotification.renderContents(returnedJson, false);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
        this.enableButton();
    }
  }
  customElements.define('add-all-from-wishlist-to-cart', addAllFromWishlistToCart);


/**
 * custom element for handling removing all items from the
 * shown/current wish list
 */
class EmptyWishlist extends WishlistPageControls {
    constructor() {
        super();
        this.confirmBoxId = 'confirm-remove-all';
        this.btn.addEventListener('click', this.removeAllItemsFromWishlist.bind(this));
        this.init();
    }

    async removeAllItemsFromWishlist(e) {
        this.disableButton();
        if(await this.waitForUserConfirm()) {
            e.preventDefault();
            e.stopPropagation();

            const obj = {
                removeAll: true,
                sessionId: window.currentWishlist.sessionId,
                products: []
            }

            await fetch('/apps/wishlist/removeproducts', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify(obj)
            })
            .then((response) => {
                return response.json();
            })
            .then((returnedJson) => {
                // second argument to handleNewData, wishlistpage is set to false even though we're on the wishlist page, because it means that the data on the page will refresh
                this.wishlistDataElement.handleNewData(returnedJson,false,'removeAllItemsFromWishlist');
                if(returnedJson.errorMessage) {
                    console.error(`Error in removeAllItemsFromWishlist: ${returnedJson.errorMessage}`);
                    this.wishlistDataElement.showErrorPopup(returnedJson.errorMessage);
                }
            }).catch(error => {
                console.error(`Error in removeAllItemsFromWishlist (2): ${error}`);
                this.wishlistDataElement.showErrorPopup();
            });
        }
        this.enableButton();
    }

}
customElements.define('empty-wishlist', EmptyWishlist);



/* custom element for handling sharing wishlist link via email */
  class wishlistShareEmail extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector('.wishlist-share__email-submit');
        this.input = this.querySelector('.wishlist-share__input');
        if (!this.btn) {
            return;
        }
        this.btn.addEventListener('click', (e) => { this.openEmail(e); });
    }

    /**
     * open user's email client with recipient, subject and body already set
     * @param {event} e , when you click the button
     */
    openEmail(e){
        e.preventDefault();
        const subj = this.decodeHtml(wishlistPageTranslations.emailShare.subject);
        let bodyText = this.decodeHtml(wishlistPageTranslations.emailShare.body);
        const email = this.decodeHtml(this.input.value);

        const reg = /{{ ?link ?}}/gm;
        bodyText = bodyText.replace(reg, location.href);

        location.href=`mailto:${encodeURI(email)}?subject=${encodeURI(subj)}&body=${encodeURI(bodyText)}`;
    }

    /**
     * decode html string (so that you can write special chars like quotes in the body translation)
     * @param {html} html the html string you need to decode
     * @returns the decoded html string
     */
    decodeHtml(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

}
customElements.define('wishlist-share-email', wishlistShareEmail);



/* Handles the facets (sorting facets) on the wish list page only */
class facetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.sortSelect = this.querySelector('#SortBy');
        this.sortValue = '';
        if (!this.sortSelect) {
            return;
        }
        this.classList.remove('small-hide', 'medium-hide');
        this.sortSelect.addEventListener('change', () => { this.changeSorting(); });
    }

    /**
     * redirect to same page but with different sorting params in the url
     */
    changeSorting() {
        this.sortValue = this.sortSelect.value;
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('sort_by', this.sortValue);
        window.location.href = newUrl;

    }
}
customElements.define('facet-filters-form', facetFiltersForm);



/* Handles the share component on the wish list page */
class wishlistShare extends HTMLElement {
    constructor() {
        super();
        document.addEventListener('wishlistItemsInited', () => {this.init(); });
    }

    init() {
        if(window.wishlistPageShownWishlist.products.length) {
            this.wishListItemsComponent = document.querySelector('wishlist-page-items');
            this.handleShareFunctionsIfOwner();
        }
    }

    /**
     * show share functions if the user owns the wish list
     */
    handleShareFunctionsIfOwner() {
        if(this.wishListItemsComponent.isWishlistOwner) {
            this.classList.remove('hidden');
            this.removeAttribute('aria-hidden');
        }else {
            this.remove();
        }
    }


}
customElements.define('wishlist-share', wishlistShare);


/* Handles the share component on the wish list page */
class wishlistSignupEncouraging extends HTMLElement {
    constructor() {
        super();
        document.addEventListener('wishlistItemsInited', () => {this.init(); });
    }

    init() {
        if(window.wishlistPageShownWishlist.products.length) {
            this.wishListItemsComponent = document.querySelector('wishlist-page-items');
            this.handleSignupFunctionsIfOwner();
        }
    }

    /**
     * show share functions if the user owns the wish list
     */
    handleSignupFunctionsIfOwner() {
        if(this.wishListItemsComponent.isWishlistOwner && !window.customer) {
            this.classList.remove('hidden');
            this.removeAttribute('aria-hidden');
        }
    }


}
customElements.define('wishlist-signup-encouraging', wishlistSignupEncouraging);
